import React, { useEffect, useState } from 'react';
import type { Video } from '../types/video';
interface HeroImageProps {
  video: Video;
}
interface Source {
  src: string;
  /** sd/hq YouTube thumbnails are 4:3 with black bars baked in above and below the 16:9 frame */
  letterboxed: boolean;
}

// YouTube doesn't create maxres thumbnails for every upload. For missing sizes it
// returns a tiny grey 120×90 placeholder (onError doesn't always fire), so we also
// check the loaded size and step down to the next quality.
function candidates(video: Video): Source[] {
  const base = `https://i.ytimg.com/vi/${video.id}`;
  return [...(video.cover ? [{
    src: video.cover,
    letterboxed: false
  }] : []), {
    src: `${base}/maxresdefault.jpg`,
    letterboxed: false
  }, {
    src: `${base}/sddefault.jpg`,
    letterboxed: true
  }, {
    src: `${base}/hqdefault.jpg`,
    letterboxed: true
  }];
}
export function HeroImage({
  video
}: HeroImageProps) {
  const sources = candidates(video);
  const [index, setIndex] = useState(0);
  useEffect(() => setIndex(0), [video.id, video.cover]);
  const current = sources[index];
  const next = () => setIndex(i => i < sources.length - 1 ? i + 1 : i);
  const img = <img key={current.src} src={current.src} alt="" onError={next} onLoad={e => {
    if (e.currentTarget.naturalWidth <= 120) next();
  }} className={current.letterboxed ? 'absolute left-1/2 top-1/2 h-auto max-w-none -translate-x-1/2 -translate-y-1/2' : 'absolute inset-0 h-full w-full object-cover'} style={current.letterboxed ?
  // Size the 4:3 image so its inner 16:9 band always covers the hero; bars fall outside.
  {
    width: 'max(100cqw, calc(100cqh * 16 / 9))'
  } : undefined} data-id="element-52" data-mp="13u6c3dcrpasx" />;
  return <div className="absolute inset-0 -z-20 overflow-hidden bg-surface" style={{
    containerType: 'size'
  }} aria-hidden="true" data-id="element-53" data-mp="c1yvgcx9hyej">
      {img}
    </div>;
}